const { ccclass, property } = cc._decorator;
import BaseTableModel from "../../../longhudou/module/table/base_table_model";

@ccclass
export default class BJLTableModel extends BaseTableModel {

}